import { Modal } from "antd";
import LogoutIcon from "assets/icons/logout.svg";
import SettingsIcon from "assets/icons/setting.svg";
import TranslateIcon from "assets/icons/translate.svg";
import Logo from "assets/svg/logo-color.svg";
import BgTopRightIcon from "assets/svg/bgTopRight.svg";
import BgBottomLeftIcon from "assets/svg/bgBottomLeft.svg";
import useAuthHook from "hooks/useAuthHook";
import { useEffect, useMemo, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom"; // Import useLocation
import { toast } from "react-toastify";
import { useLogoutMutation } from "services/auth";
import { useGetPreAppStatusQuery } from "services/auth";
import * as LOCAL_STORAGE_KEYS from "shared/constants/localStorageKeys";
import routes, { appRoute } from "shared/constants/routes";
import { LANGUAGES, useTranslation } from "../../../contexts/TranslationContext";
import HomeProductSectionBg from "assets/svg/HomeProductSectionBg.svg";

export default function Layout({ children }) {
  const { logout } = useAuthHook();
  const [confirmModal, setConfirmModal] = useState(false);
  const [doLogout, { isLoading }] = useLogoutMutation();
  const { translate, language, setLanguage } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { getUser } = useAuthHook();

  const user = getUser();
  const userId = user ? String(user.IDB_USR_ID) : null;

  const onLogout = () => {
    setConfirmModal(true);
  };

  const handleToggleLanguage = () => {
    const nextLang = language?.code === LANGUAGES.ar.code ? LANGUAGES.en : LANGUAGES.ar;
    setLanguage(nextLang);
  };
   //commenting out pre-app status check
  // const { data, isError, refetch } = useGetPreAppStatusQuery(
  //   { id: userId },
  //   {
  //     skip: !userId,
  //     refetchOnMountOrArgChanges: true,
  //     refetchOnFocus: true,
  //     refetchOnReconnect: true,
  //   }
  // );
  // // Trigger refetch on route change
  // useEffect(() => {
  //   if (userId) {
  //     refetch(); // Force refetch whenever the route changes
  //   }
  // }, [location.pathname, refetch, userId]);

  // if (isError) {
  //   toast.error("Failed to fetch pre app status. Please check network and API.");
  // }

  // useEffect(() => {
  //   const untouchedRoutes = [
  //     "/app/setting/personal-detail",
  //     "/app/setting/address-detail",
  //     "/app/setting/marital-status",
  //     "/app/setting/eligibility",
  //   ].includes(location?.pathname);
  //   if (data?.result?.completedSteps.length < 4 && !untouchedRoutes) {
  //     navigate(appRoute(routes.PRE_APP));
  //   }
  // }, [data, location.pathname, navigate]);

  return (
    <div className="min-h-screen flex flex-col relative pb-24">
      {/* background image for product section (fixed to viewport)  */}
        <div className="absolute top-0 w-full z-0 hidden sm:block">
          <img
            src={HomeProductSectionBg}
            alt="Product section Background"
            className="absolute w-full -z-10"
          />
        </div>

        {/* Header with improved z-index */}
      <header className="relative z-10 w-full min-h-16 mb-4 px-6 py-4 bg-transparent flex items-center">
        <div className="flex items-center">
          <Link to="/app/pre">
            <img alt="App logo" src={Logo} className="cursor-pointer h-8 sm:h-10" />
          </Link>
        </div>
        <div className="flex-grow" />
        <div className="flex items-center gap-3 sm:gap-4 lg:gap-5">
          {location.pathname !== "/app/setting" && location.pathname !== "/app/pre" && (
            <button
              type="button"
              onClick={() => navigate("/app/setting")}
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white shadow-[0_6px_18px_rgba(3,0,71,0.09)] flex items-center justify-center border border-white"
            >
              <img alt="Settings" src={SettingsIcon} className="w-4 h-4" />
            </button>
          )}
          <button
            type="button"
            onClick={onLogout}
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white shadow-[0_3px_18px_rgba(3,0,71,0.09)] flex items-center justify-center border border-white"
          >
            <img alt="Logout" src={LogoutIcon} className="w-4 h-4" />
          </button>
          <button
            type="button"
            onClick={handleToggleLanguage}
            className="flex items-center gap-2 pl-3 pr-4 py-1.5 rounded-full bg-white shadow-[0_6px_18px_rgba(3,0,71,0.09)] border border-white"
          >
            <span className="w-8 h-8 rounded-full bg-[#F5FCFF] flex items-center justify-center">
              <img alt="Translate" src={TranslateIcon} className="w-4 h-4" />
            </span>
            <span className="text-xs sm:text-sm font-medium text-[#1F1F1F]">
              {language?.shortname}
            </span>
          </button>
        </div>
      </header>

      {/* Main content container with flex-grow */}
      <main className="relative z-5 container mx-auto px-4 sm:px-6 lg:px-8 flex-grow">
        <Outlet />
      </main>

      {/* Bottom left image - positioned at the end of the content */}
      {/* <div className="absolute bottom-0 left-0 w-full mt-auto -z-100">
        <div className="w-2/5 md:w-2/5 lg:w-2/5">
          <img
            src={BgBottomLeftIcon}
            alt="Bottom Left Decoration"
            className="w-full"
          />
        </div>
      </div> */}

      {/* Confirmation Modal */}
      <Modal
        open={confirmModal}
        title={translate("HOME.ARE_YOU_SURE")}
        onCancel={() => setConfirmModal(false)}
        okType="dashed"
        okButtonProps={{ loading: isLoading }}
        onOk={async () => {
          const user = localStorage.getItem(LOCAL_STORAGE_KEYS.USER);
          const userId = JSON.parse(user)?.IDB_USR_ID;

          if (userId) {
            await doLogout({ userId });
            logout();
            setConfirmModal(false);
          }
        }}
      ></Modal>
    </div>
  );
}
